import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { CampaignAdminDto } from '@/backend/market'
import { CampaignsMiniEntity } from '../../domain/entities/CampaignsMiniEntity'

export class CampaignsMiniModel extends CampaignsMiniEntity {
  constructor(dataDto: CampaignAdminDto) {
    super()
    mapEntityProperties<CampaignsMiniEntity>(this, dataDto)
  }
}
